module.exports = __webpack_public_path__ + "img/zhihuishoushushi.3364251c.png";